<template>
    <div class="msg-sent content-container">
        <div class="header">
            <div class="title">
                Sent Messages
                <button class="button-float-right" @click="deleteSelectedMessages">Delete</button>
            </div>
            
        </div>
        <div class="content nopad msg-received-list">
            <div class="blocklist-header columntitles">
                <div class="select-all">
                    <input type="checkbox" name="selectAll" v-model="selectAll">
                    <label for="selectAll" >Select All</label>
                </div>
                <div class="status">Status</div>
                <div class="subject">Subject  <input type="text" class="search-filter" placeholder="Search" v-model="serach"> </div>
                <div class="from">To <input type="text" class="search-filter" placeholder="Search" v-model="fromSearch"></div>
                <div class="recd-date">Date/Time  <span class="date-sort" @click="toggleDateSort">{{dateSort}}</span></div>                
            </div>
            <MessageSentListItem v-for="message in sortedMessages" :key="message.messageID" :message="message" 
                :isChecked="shouldCheck(message.messageID)" @checkChanged="checkChanged" @deleteMessage="deleteMessage"></MessageSentListItem>
        </div>
    </div>
</template>

<script>

    import MessageSentListItem from '../../components/Messages/MessageSentListItem'
    import api from '../../api/api'
    import moment from 'moment';
    import dialogs from '../../modules/dialogs'

    export default {
        data() {
            return {
                messages: null,
                serach: '',
                dateSort: 'descending',
                fromSearch: '',
                selectAll: null,
                checkedMessages: [],
            }
        },
        components: {
            MessageSentListItem
        },
        computed: {
          sortedMessages() {
            if(!this.filteredMessages){
              return [];
            }
            if(this.dateSort == 'ascending') {
              const arr = this.filteredMessages.concat().sort((a,b) => {
                const aMom = moment(a.sentDateUTC);
                const bMom = moment(b.sentDateUTC);
                return aMom.isAfter(bMom) ? 1 : -1;
              });

              return arr;
            }
            const dArr = this.filteredMessages.concat().sort((a,b) => {
                const aMom = moment(a.sentDateUTC);
                const bMom = moment(b.sentDateUTC);
                return aMom.isBefore(bMom) ? 1 : -1;
              });
              return dArr;
            
          },
          filteredMessages() {
            let result = this.messages;
            if(this.serach && this.serach != ''){
              result = result.filter(r=> {
                return r.subject.toLowerCase().includes(this.serach.toLowerCase())
              });
            }
            if(this.fromSearch && this.fromSearch != ''){
              result = result.filter(r=> {
                return r.toMemberDisplayName.toLowerCase().includes(this.fromSearch.toLowerCase())
              });
            }
            return result;
          },
        },
        methods: {
            getMessages: function() {
                api.get('/messages/sent')
                .then((response) => {
                    this.messages = response.data;
                });
            },
            toggleDateSort() {
              this.dateSort = this.dateSort == 'ascending' ? 'descending' : 'ascending';
            },
            checkChanged(data){
                if(!this.checkedMessages){
                    this.checkedMessages = [];
                }
                if(data.value){
                    if(!this.checkedMessages.includes(data.messageID)){
                        this.checkedMessages.push(data.messageID);
                    }
                }
                else{
                    if(this.checkedMessages.includes(data.messageID)){
                        const index = this.checkedMessages.indexOf(data.messageID);
                        if(index > -1) {
                            this.checkedMessages.splice(index,1);
                        }
                    }
                }
            },
            shouldCheck(messageID){
                if(this.checkedMessages) {
                    if(this.checkedMessages.includes(messageID)){
                        return true;
                    }
                }
                return false;
            },
            async deleteSelectedMessages() {
                if(this.checkedMessages && this.checkedMessages.length) {
                    await this.confirmAndDeleteMessages(this.checkedMessages);
                }
            },
            async deleteMessage(message) {
                await this.confirmAndDeleteMessages([message.messageId]);
            },
            async confirmAndDeleteMessages(messageIds) {
                if (await dialogs.confirmAsync('Are you sure you want to delete this message(s)?')) {
                    api.post('/messages/deleteSentMessages', {
                        messagesIds: messageIds,
                    }).then(() => {
                        this.getMessages();
                        this.checkedMessages = [];
                    })
                }
            },
        },
        mounted() {
            this.getMessages();
        },
        watch:{
            selectAll(newValue){
                if(newValue){
                    if(this.messages) {
                        this.checkedMessages = this.messages.map(m => m.messageID);
                    }
                }
                else{
                    this.checkedMessages = [];
                }
            },
        },
    }

</script>

<style scoped>

</style>